<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="large" color="#fff" type="ball-pulse"></ngx-spinner>
<app-alerts></app-alerts>
<router-outlet></router-outlet>
